import "./style.scss";
import { useEffect, useState } from "react";
import SelectFilialUI from "@UI/SelectFilialUI";

const FilialBlock = ({ data, setFilialObj, filialObj, errorCity, errorFilial, setErrorFilial, setErrorCity }) => {
    const [city, setCity] = useState(false);
    const [filial, setFilial] = useState(false);

    useEffect(() => {
        if (data?.addresses?.length === 1) {
            setCity(data.addresses[0]);
            setErrorCity(false);
        }
    }, [data]);

    useEffect(() => {
        setFilial(false);
    }, [city]);

    const handleChange = (id, el) => {
        if (id === "city") {
            setCity(el);
            setFilialObj({ city: el.city });
        } else {
            setFilialObj({ ...filialObj, [id]: el.text });
            setFilial(el);
        }
        if (data?.addresses?.length === 1) {
            setFilialObj({ [id]: el.text, city: data?.addresses[0].city });
        }
    };

    return (
        <div className="filial__block">
            {data?.addresses?.length === 1 ? null : (
                <SelectFilialUI id={"city"} error={errorCity} setError={setErrorCity} data={data?.addresses.filter((f) => !("isSelect" in f) || f.isSelect)} onChance={handleChange} title={city ? city.city : "Выберите город"} isEmpty={!city} />
            )}
            <SelectFilialUI error={errorFilial} setError={setErrorFilial} id={"filial"} data={city.address} disable={!city} onChance={handleChange} title={filial ? filial.text : data?.title} city={city} isEmpty={!filial} />
        </div>
    );
};

export default FilialBlock;
